export default "__VITE_ASSET__BtSNVbG___"